<template >
    <div class="container">

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">

        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Хичээл нэмэх</h1>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label>Хичээлийн нэр</label>
                      <input v-model.trim="lesson.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хичээлийн нэр">
                    </div>
                    <div class="form-group">
                      <label>Дэлгэрэнгүй</label>
                      <textarea v-model.trim="lesson.description" type="text" class="form-control" id="exampleInputPassword" placeholder="Дэлгэрэнгүй" rows="10"/>
                    </div>
                    <!-- <div class="form-group">
                      <label>Хичээлийн үнэ</label>
                      <input v-model.number="lesson.price" type="number" class="form-control"  placeholder="Хичээлийн үнэ">
                    </div> -->
             

                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Төрөл:</label>
                      <select class="form-control" v-model='lesson.typeDetail'>
                        <option v-for="type in types" v-bind:key="'type-'+type.id" v-bind:value="type">{{type.name}}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Aнги/группээр орох:</label>
                      <div class="form-check">
                        <input v-model="lesson.isGroup" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-bind:value="false">
                        <label class="form-check-label" for="exampleRadios1">
                          Ангиар ороx
                        </label>
                      </div>
                      <div class="form-check">
                        <input v-model="lesson.isGroup" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-bind:value="true">
                        <label class="form-check-label" for="exampleRadios2">
                          Группээр ороx
                        </label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Секц:</label>
                        <select class="form-control" v-model='lesson.sector'>
                          <option v-for="type in sectors" v-bind:key="'sector-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Ангилал:</label>
                        <select class="form-control" v-model='lesson.category'>
                          <option v-for="type in categories" v-bind:key="'type-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row" v-if="setTeacher && setTeacher==true && teachers && teachers.length>0">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Хичээл заах багш:</label>
                        <select class="form-control" v-model="selectedTeacher">
                          <option v-for="teacher in teachers" v-bind:key="'teacher-'+teacher.id" v-bind:value="teacher">{{teacher.name}} - {{teacher.code}} - {{teacher.email}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Хичээл орох ангиуд</label>
                      <div class="row">
                        <div class="col form-group">
                          <select class="form-control" v-model='department'>
                            <option v-for="type in departments" v-bind:key="'type-'+type.id" v-bind:value="type">{{type.index}} анги</option>
                          </select>
                        </div>
                        <div class="col col-2 ">
                          <div @click="addClass" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul v-if="lesson.classNos!=null && lesson.classNos.length>0">
                        <li v-for="(include, index) in lesson.classNos" >{{include}} анги
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.classNos)"></i>
                        </li>
                      </ul>
                    </div>
                    <!-- <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Хичээл орох анги:</label>
                        <select class="form-control" v-model=''>
                          <option v-for="type in paymentTypes" v-bind:key="'type-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                    </div>
   -->
                  
                    <div class="form-group">
                       <label>Зорилго</label>
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="result" type="text" class="form-control" placeholder="Зорилго"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addResult" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.results!=null && lesson.results.length>0">
                        <li  v-for="(include,index) in lesson.results" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.results)"></i>
                        </li>
                      </ul>
                    </div>
                    <div class="form-group">
                       <label>Эзэмшүүлэх мэдлэг</label>
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="whatlearned" type="text" class="form-control" placeholder="Эзэмшүүлэх мэдлэг"/>
                        </div>
                        <div class="col col-2 ">
                          <div @click="addLearned" class="btn btn-success btn-block">
                            нэмэх
                          </div>
                        </div>
                      </div>
                      <ul v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
                        <li v-for="(include, index) in lesson.whatlearned" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.whatlearned)"></i>
                        </li>
                      </ul>
                    </div>

                     <div class="form-group">
                       <label>Xүний ур чадвар, хандлага</label>
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="handlagaText" type="text" class="form-control" placeholder="Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addHandlaga" class="btn btn-success btn-block">
                          нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
                        <li  v-for="(include, index) in lesson.handlaga" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.handlaga)"></i>
                        </li>
                      </ul>
                    </div>

                      <div class="form-group">
                        <label>Шаардлага</label>
                      <div class="row">
                        <div class="col col-10">
                          <textarea v-model.trim="requirement" type="text" class="form-control" placeholder="Хичээлийн шаардлага (Зөөврийн компьтертэй байх зэрэг шаардлага)"/>
                        </div>
                        
                        <div class="col col-2 ">
                          <div @click="addRequirement" class="btn btn-success btn-block">
                          нэмэх
                          </div>
                        </div>
                      </div>
                      <ul  v-if="lesson.requirements!=null && lesson.requirements.length>0">
                        <li  v-for="(include, index) in lesson.requirements" v-bind:key="include">{{include}}
                           <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.requirements)"></i>
                        </li>
                      </ul>
                    </div>
                    <!-- <div class="form-group">
                      <div class="custom-control custom-checkbox small">
                        <input type="checkbox" class="custom-control-input" id="customCheck">
                        <label class="custom-control-label" for="customCheck">Remember Me</label>
                      </div>
                    </div> -->
                    <hr/>
                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>
                  
                 
                
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../../../firebaseConfig.js');
import { mapState } from 'vuex';
export default {
    name: "LessonAdd",
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    data() {
        return {
            lesson: {
                name: '',
                description: '',
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                teacherFirstName:'',
                teacherLastName:'',
                // skills:[],
                handlaga:[],
                semester:null, 
                credit:null,
                types:[],
                price:0,
                type:null
               
            },
            performingRequest:false,
            requirement:'',
            result:'',
            whatlearned:'',
            // skill:'',
            handlagaText:'',
            schools:[],
            school:null,
            department:null,
            program:null,
            semesters:[],
            semester:null,
            departments:[],
            lessonTypes:[
              "Ерөнхий эрдэм",
              "Мэргэжлийн",
              "Мэргэжлийн суурь",
              "Сонгох",
              "Магистр",
              "Доктор"
            ],
            paymentTypes:[],
            categories:[],
            teachers:[],
            selectedTeacher:null,
            sectors:[],
            types:[]
 
        };
    },
    methods: {
        async save() {
         
            this.performingRequest = true;
            if(this.lesson!=null && this.lesson.name!='' && this.lesson.category!=null && this.lesson.category!='' && this.lesson.isGroup!=null && this.lesson.isGroup!=undefined){
              if(this.lesson.typeDetail && this.lesson.typeDetail.ref){
                this.lesson.type=this.lesson.typeDetail.ref;
              }
              this.lesson.name=this.capitalizeFirstLetter(this.lesson.name);
                this.lesson.userId=this.$store.getters.currentUser.uid;
                this.lesson.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                if(this.setTeacher && this.setTeacher==true && this.selectedTeacher && this.selectedTeacher.ref){
                  this.lesson.teacher=this.selectedTeacher.ref;
                  var teacherDoc=await this.selectedTeacher.ref.get();
                  this.lesson.teachers=[];
                  this.lesson.teacherRefs=[];
                  this.lesson.teachers.push({
                    "firstName": teacherDoc.data().firstName!=undefined && teacherDoc.data().firstName!=null?teacherDoc.data().firstName:teacherDoc.data().name,
                    "lastName": teacherDoc.data().lastName!=undefined && teacherDoc.data().lastName!=null?teacherDoc.data().firstName:teacherDoc.data().lastname,
                    "description": teacherDoc.data().description!=undefined && teacherDoc.data().description!=null?teacherDoc.data().description:'Багш',
                    "reference": teacherDoc.ref
                  });

                  this.lesson.teacherRefs.push(teacherDoc.ref);

                  if(teacherDoc.data().firstName){
                    this.lesson.teacherFirstName=teacherDoc.data().firstName;
                  }
                  if(teacherDoc.data().lastName){
                    this.lesson.teacherLastName=teacherDoc.data().lastName;
                  }
                  

                }
                else if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
                  this.lesson.teacher=this.$store.getters.userProfile.customer;
                  var teacherDoc=await this.$store.getters.userProfile.customer.get();
                  this.lesson.teachers=[];
                  this.lesson.teacherRefs=[];
                  this.lesson.teachers.push({
                    "firstName": teacherDoc.data().firstName!=undefined && teacherDoc.data().firstName!=null?teacherDoc.data().firstName:teacherDoc.data().name,
                    "lastName": teacherDoc.data().lastName!=undefined && teacherDoc.data().lastName!=null?teacherDoc.data().firstName:teacherDoc.data().lastname,
                    "description": teacherDoc.data().description!=undefined && teacherDoc.data().description!=null?teacherDoc.data().description:'Багш',
                    "reference": teacherDoc.ref
                  });

                  if(teacherDoc.data().firstName){
                    this.lesson.teacherFirstName=teacherDoc.data().firstName;
                  }
                  if(teacherDoc.data().lastName){
                    this.lesson.teacherLastName=teacherDoc.data().lastName;
                  }
                  
                  this.lesson.teacherRefs.push(teacherDoc.ref);
                }
                this.lesson.createdAt=new Date();
                this.lesson.checkedAt=new Date();
                this.lesson.lectureCode=new Date().getTime();
                this.lesson.school=null;
                if(this.schoolId){
                  this.lesson.school=fb.db.collection("schools").doc(this.schoolId);
                  fb.db.collection("schools").doc(this.schoolId).update({
                    'numberOfLessons': fb.firestore.FieldValue.increment(1)
                  });
                }
   
                await fb.db.collection("schools").doc(this.schoolId).collection("lessons").doc().set(this.lesson);
                if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
                  this.lesson.teacher=this.$store.getters.userProfile.customer;
                  this.lesson.teacher.update({'numberOfLessons':fb.firestore.FieldValue.increment(1)});
                }

                this.$router.back();
            }
            else{
              alert("Та хичээлийнхээ нэр, ангилал болон анги/группээр орох гэсэн талбаруудыг бөглөнө үү");
            }
        },
        setLesson(){
          this.lesson={
                name: '',
                description: '',
                included:[],
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                skills:[],
                handlaga:[],
                semester:null,
                credit:null,
                types:[],
                price:0,

            }
        },
        addIncluded(){
          if(this.included!=null && this.included!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.included.push(this.included)
            this.included=''
          }
        },
        addRequirement(){
          if(this.requirement!=null && this.requirement!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.requirements.push(this.requirement)
            this.requirement=''
          }
        },
        addResult(){
          if(this.result!=null && this.result!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.results.push(this.result)
            this.result=''
          }
        },
        addLearned(){
          if(this.whatlearned!=null && this.whatlearned!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.whatlearned.push(this.whatlearned)
            this.whatlearned=''
          }
        },
        addSkill(){
          if(this.skill!=null && this.skill!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.skills.push(this.skill)
            this.skill=''
          }
        },
        addHandlaga(){
          if(this.handlagaText!=null && this.handlagaText!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.handlaga.push(this.handlagaText)
            this.handlagaText=''
          }
        },
        addClass(){
          if(this.department && this.department.index && this.department.index>0){
            if(!this.lesson.classNos)
              this.lesson.classNos=[];
            var exists=false;
            if(this.lesson.classNos){
              for(const classNo of this.lesson.classNos){
                if(classNo && classNo==this.department.index ){
                  exists=true;
                  break;
                }
              }
            }
            if(exists!=true){
              this.lesson.classNos.push(this.department.index);
              this.department=null;
            }

          }
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },

        addType(type){
          if(this.lesson.types==null || this.lesson.types==undefined)
            this.lesson.types=[];
          if(!this.lesson.types.includes(type))
            this.lesson.types.push(type);
          else
            this.lesson.types.splice(this.lesson.types.indexOf(type), 1); 
        },
   
        capitalizeFirstLetter(str){
          return  str.charAt(0).toUpperCase() + str.slice(1);
        },
        async _getCategories(){
          var types=await fb.db.collection("lessontypes").orderBy("index").get();
          if(types && !types.empty){
            types.docs.forEach(value=>{
              let item=value.data();
              item.id=value.id;
              item.ref=value.ref;
              this.types.push(item);
            });
          }

          fb.db.collection("schools/"+this.schoolId+ "/categories").orderBy("index")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.categories.push(object);
              });
         
          });

          fb.db.collection("schools/"+this.schoolId+ "/sectors").orderBy("name")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.sectors.push(object);
              });
         
          });

          fb.db.collection("schools/"+this.schoolId+ "/departments").orderBy("index")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.departments.push(object);
              });
         
          });

          if(this.setTeacher && this.setTeacher==true){
            fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name").get().then(querySnapshot=>{
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.teachers.push(object);
              });
            });
          }
        }

    }, 
   
    created() {
      if(this.schoolId)
        this._getCategories();
            
    },
    props: {
      schoolId: { 
        required: true,
      },
      setTeacher:{
        required:false
      }
    }
  
};
</script>

